import { useTranslation } from "@emisgroup/acp-application-intl";
import { TableDataRowProps, TableHeaderProps, TableProps } from "../../../../Common/UI/Index";

function ColumnDefinition(): TableHeaderProps[] {

  // Translation service
  const { t:translate } = useTranslation();

  // Define the columns for the table
  const columns: TableHeaderProps[] = [
    {
      title: translate("Scheduling.Heading.ScheduleName"),
      propertyName: "scheduleName",
      width: "33%"
    },
    {
      title: translate("Scheduling.Heading.ActiveIn"),
      propertyName: "activeInLive",
      width: "10%"
    },
    {
      title: translate("Scheduling.Heading.RecurrenceTypeId"),
      propertyName: "recurrenceType",
      width: "17%"
    },
    {
      title: translate("Scheduling.Heading.StartOfRecurrence"),
      propertyName: "recurrenceRangeStart",
      width: "15%"
    },
    {
      title: translate("Scheduling.Heading.EndOfRecurrence"),
      propertyName: "recurrenceRangeEnd",
      width: "15%"
    },
    {
      title: translate("Scheduling.Heading.Validity"),
      propertyName: "validity",
      width: "10%"
    }
  ];

  return columns;
}

/**
 * To populate the table data
 * @param scheduleList customized response data
 * @returns the formatted data to bind the table
 */
export const PopulateCustomTable = (scheduleList: TableDataRowProps[]): TableProps => {
  const table = {
    headerRow: ColumnDefinition(),
    dataRow: scheduleList
  };

  return table;
};
